type Size = 'cm'

export const SIZE: Record<Size, string> = {
  cm: 'cm',
}
